/** ***********
*
* <beacon-layer.action.ts v1.0>
*
* Copyright (c) 2023 AIRBUS OPERATIONS
*
* Contributors:
*  GARY Adrien (NG635E8) [adrien.gary.external@airbus.com]
*
* All rights reserved.
**************/

import { EsriBeacon } from './../../models/beacon';
import { createAction, props } from '@ngrx/store';

export const fetchBeaconLayer = createAction('[beacons] Load Beacon Layer');
export const successFetchBeaconLayer = createAction('[beacons] Success Beacon Layer', props<{ beacons: EsriBeacon[] }>());
export const errorFetchBeaconLayer = createAction('[beacon] Error Beacon Layer');
export const resetBeaconLayer = createAction('[beacon] Reset Beacon Layer');
